import React, { useReducer } from "react";
import { Button, Form, Modal, Input, TextArea } from "semantic-ui-react";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

import { server } from "../../../App";
import axios from "axios";
import moment from "moment";

function Note(props) {
  const [state, dispatch] = useReducer(reducer, initialState);

  // const [odVal, set_Od_Val] = useState("")
  // const [ogVal, set_Og_Val] = useState("")

  const { ID, syncData, AuthState } = props;

  const onValueChanged = async () => {
    const ValuesToCreate = {
      fk_id_patientConsul: ID,
      created_by: AuthState.user_name,
      og: ` - ${state.og} - Pachy OG : ${state.og_Pachy} µm`,
      od: ` - ${state.od} - Pachy OD : ${state.od_Pachy} µm`,
      fk_id_examen: 11,
      observation: `${state.observation
        } - Tension mesurée à : ${moment().format("HH:mm")}`,
    };

    axios({
      method: "post",
      responseType: "json",
      url: `${server}Consultation`,
      data: ValuesToCreate,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        syncData(response.data);
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  async function getOneUser() {
    await axios
      .get(`${server}dataPio/data.json`)
      .then((response) => {
        delete response.data.a0;
        delete response.data.a1;
        delete response.data.a2;
        let xxx = Object.values(response.data);

        let val = xxx.toString();
        let newStr = val.replace(/-/g, "_");

        val = newStr.split(":").toString().split(",");

        function chunkArray(arr, n) {
          let chunkLength = Math.max(arr.length / n, 1);
          let chunks = [];
          for (let i = 0; i < n; i++) {
            if (chunkLength * (i + 1) <= arr.length)
              chunks.push(arr.slice(chunkLength * i, chunkLength * (i + 1)));
          }
          return chunks;
        }
        let couple = val.length / 2;
        let qq = chunkArray(val, couple);

        const entries = new Map(qq);
        const obj = Object.fromEntries(entries);
        dispatch({ type: ACTION.IMPORT_DATA_MACHINE_PACHY, payload: obj });
      })
      .catch((error) => {
        dispatch({ type: "FETCH_ERROR", payload: error.response });
      });
  }

  async function getPioTopCon() {
    await axios
      .get(`${server}dataPioTopCon/data.json`)
      .then((response) => {
        delete response.data.a0;
        delete response.data.a1;
        delete response.data.a2;
        delete response.data.a3;
        delete response.data.a4;
        delete response.data.a5;
        delete response.data.a6;
        delete response.data.a7;
        let xxx = Object.values(response.data);

        let PATTERNAMMR = /AMMR/,
          filteredAMMR = xxx.filter(function (str) {
            return PATTERNAMMR.test(str);
          });
        let PATTERNTAR = /TAR/,
          filteredTAR = xxx.filter(function (str) {
            return PATTERNTAR.test(str);
          });
        let PATTERNAMML = /AMML/,
          filteredAMML = xxx.filter(function (str) {
            return PATTERNAMML.test(str);
          });
        let PATTERNTAL = /TAL/,
          filteredTAL = xxx.filter(function (str) {
            return PATTERNTAL.test(str);
          });

        let all = [
          ...filteredAMMR,
          ...filteredTAR,
          ...filteredAMML,
          ...filteredTAL,
        ];

        let val = all.toString();
        let newStr = val.replace(/ /g, "");

        newStr = newStr.replace(/AMMR/g, `T_R_A:`);
        newStr = newStr.replace(/TAR/g, `P_R_A:`);
        newStr = newStr.replace(/AMML/g, `T_L_A:`);
        newStr = newStr.replace(/TAL/g, `P_L_A:`);

        val = newStr.split(":").toString().split(",");

        function chunkArray(arr, n) {
          let chunkLength = Math.max(arr.length / n, 1);
          let chunks = [];
          for (let i = 0; i < n; i++) {
            if (chunkLength * (i + 1) <= arr.length)
              chunks.push(arr.slice(chunkLength * i, chunkLength * (i + 1)));
          }
          return chunks;
        }
        let couple = val.length / 2;
        let qq = chunkArray(val, couple);

        const entries = new Map(qq);
        const obj = Object.fromEntries(entries);

        dispatch({ type: ACTION.IMPORT_DATA_MACHINE_PACHY, payload: obj });
      })
      .catch((error) => {
        dispatch({ type: "FETCH_ERROR", payload: error.response });
      });
  }

  let nbrButtonToDisplay

  if (process.env.REACT_APP_MACHINES === "2") {

    nbrButtonToDisplay = <>
      <Button floated="right" color="violet" onClick={() => getOneUser()}>
        Huvitz
      </Button>
      <Button floated="right" color="blue" onClick={() => getPioTopCon()}>
        TopCon
      </Button>
    </>

  } else if (process.env.REACT_APP_MACHINES === "3") {
    nbrButtonToDisplay =
      <Button floated="right" color="violet" onClick={() => getOneUser()}>
        Huvitz
      </Button>
  } else if (process.env.REACT_APP_MACHINES === "4") {
    nbrButtonToDisplay =
      <Button floated="right" color="blue" onClick={() => getPioTopCon()}>
        TopCon
      </Button>
  }

  return (
    <>
      <Button
        color="violet"

        onClick={() => dispatch({ type: ACTION.OPEN, size: "small" })}
      >
        PIO
      </Button>
      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
      >
        <Modal.Header>
          Examen PIO
          {nbrButtonToDisplay}
        </Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths="equal">
              <Form.Field
                autoFocus
                value={state.od}
                label="Oeil Droit"
                control={Input}
                placeholder="OD"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_od,
                    payload: data.value,
                  })
                }
              // onChange={(e, data) => {
              //     set_Od_Val(data);
              // }}
              />
              <Form.Field
                value={state.og}
                label="Oeil Gauche"
                control={Input}
                placeholder="OG"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_og,
                    payload: data.value,
                  })
                }
              // onChange={(e, data) => {
              //     set_Og_Val(data);
              // }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                value={state.od_Pachy}
                label="Pachy Oeil Droit"
                control={Input}
                placeholder="0 µm"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_od_Pachy,
                    payload: data.value,
                  })
                }
              // onChange={(e, data) => {
              //     set_Od_Val(data);
              // }}
              />
              <Form.Field
                value={state.og_Pachy}
                label="Pachy Oeil Gauche"
                control={Input}
                placeholder="0 µm"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_og_Pachy,
                    payload: data.value,
                  })
                }
              // onChange={(e, data) => {
              //     set_Og_Val(data);
              // }}
              />
            </Form.Group>
            <TextArea
              placeholder="Ajouter une observation"
              //  onInput={(e, data) => dispatch({ type: ACTION.Fill_FORM_DATA, payload: data })}
              onChange={(e, data) =>
                dispatch({
                  type: ACTION.Fill_FORM_DATA_3_COLUMN_observation,
                  payload: data.value,
                })
              }
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button color="blue" onClick={() => dispatch({ type: ACTION.CLOSE })}>
            Retour
          </Button>
          <Button positive onClick={onValueChanged}>
            Valider
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default Note;
